import React, { useState, useCallback } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { ExerciseTransition } from '@astrid/components'
import { trackExerciseActivity, exerciseScore } from 'api/activityApi'
import { astridGetScore } from 'api/astridApi'
import useThunkDispatch from 'hooks/useThunkDispatch'
import { asyncUpdateGlobalScore, selectCurrentUser } from 'store/services/User'
import { BuildingExerciseData, Exercise, ExerciseType } from 'store/services/Exercise'
import { routes } from 'routes/RouterStackComponent'

import './LevelUpFactory.scss'

interface IProps {
  exercises: Exercise[]
}

const LevelUpFactory: React.FC<IProps> = ({ exercises }) => {
  const [exerciseIndex, setExerciseIndex] = useState(0)
  const dispatch = useThunkDispatch()
  const history = useHistory()

  const userCountry = useSelector(selectCurrentUser)?.profile?.country

  const assignStars = useCallback(
    async (type: ExerciseType, percentageScore?: number) => {
      if (type === ExerciseType.ReadWordRace && typeof percentageScore === 'number' && percentageScore > 60) {
        try {
          await dispatch(asyncUpdateGlobalScore(50))
        } catch (error) {}
      }

      if (type === ExerciseType.SentenceBuilder || type === ExerciseType.WordBuilder) {
        try {
          await dispatch(asyncUpdateGlobalScore(25))
        } catch (error) {}
      }
    },
    [dispatch]
  )

  const nextExercise = useCallback(
    () =>
      setExerciseIndex((current) => {
        const nextIndex = current + 1
        if (nextIndex >= exercises.length) {
          return 0
        }
        return nextIndex
      }),
    [exercises.length]
  )

  const onNextExercise = async (exercisePercentageScore?: number) => {
    const currentExercise = exercises[exerciseIndex]
    const { MultiChoiseQuestion, WordBuilder } = ExerciseType
    const { type } = currentExercise

    if ([MultiChoiseQuestion, WordBuilder].includes(type)) {
      try {
        exerciseScore(
          exercisePercentageScore!,
          type,
          type === WordBuilder ? (currentExercise.data as BuildingExerciseData).wordOrSentence : undefined
        )
      } catch (error) {}
    }

    if (exerciseIndex === exercises.length - 1) {
      assignStars(type, exercisePercentageScore)
      history.replace(routes.home)
      return
    }

    nextExercise()
  }

  return (
    <div className="level-up-factory">
      <ExerciseTransition
        exercises={exercises as any}
        country={userCountry}
        currentIndex={exerciseIndex}
        getAstridScore={astridGetScore}
        onCurrentExerciseCompleted={onNextExercise}
        trackExerciseActivity={trackExerciseActivity}
      />
    </div>
  )
}

export default LevelUpFactory
